'use strict';

import {
    addExportBtns,
    addSelectedCompanyHandler,
    getSelectedCompany,
    localeFormattedNumber,
    pjaxRedirect, printResponse
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnViiaAttachToClient = function () {
    let btnName = '#btn_attach_bank_to_client';

    if (!element_exists(btnName)) return false;

    let $btn = $(btnName);

    $btn.off('click').on('click', function (e) {
        let url = $(this).data('href');
        if (url) {
            window.open(url);
        } else {
            toastr.error('Error');
        }
    });

    addSelectedCompanyHandler(attachClient);

    function attachClient() {

        let selectedCompany = getSelectedCompany();
        let $btnCopy = $('.copy-to-clipboard');
        $btn.attr('disabled', true);
        $btn.data('href', '');

        $btnCopy.attr('disabled', true);
        $btnCopy.data('link', '');


        $.ajax({
            type: 'GET',
            url: '/viia/' + selectedCompany + '/generate-link',
            success: function (response) {
                $btn.attr('disabled', false);
                $btn.data('href', response.href);

                $btnCopy.attr('disabled', false);
                $btnCopy.data('link', response.href);
            },
            error: function (error) {
                toastr.error(error);
            }
        });
    }
}